var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebViewerExpired(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 50,
    viewBox: "0 0 38 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5124 8.99806L26.0133 9.01844L22.6213 0.416504H0.666016V50.4165H37.4801V15.2755L26.5124 8.99806Z",
    fill: "#F8FAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4793 15.2755L26.5116 8.99806L26.0125 9.01844L22.6205 0.416504H19.0723V50.4165H37.4793V15.2755Z",
    fill: "#E9EDF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6211 15.2755L37.48 15.2754L22.6211 0.416504V15.2755Z",
    fill: "#E9EDF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8599 28.1119C25.8611 26.654 26.5201 24.4745 26.5201 22.4915C26.5201 20.5085 26.5201 18.5874 26.5201 18.5874H12.0508V22.4915C12.0508 24.4745 12.7097 26.654 15.711 28.1119C16.324 28.4097 16.753 28.8375 17.053 29.2812C17.5883 30.0728 17.5883 31.1047 17.053 31.8964C16.753 32.3401 16.324 32.7679 15.711 33.0657C12.7097 34.5236 12.0508 36.7031 12.0508 38.6861V42.5902H26.5201C26.5201 42.5902 26.5201 40.6692 26.5201 38.6861C26.5201 36.7031 25.8611 34.5236 22.8599 33.0657C22.217 32.7534 21.7765 32.2981 21.4749 31.8315C20.987 31.0764 20.987 30.1012 21.4749 29.346C21.7765 28.8795 22.217 28.4242 22.8599 28.1119Z",
    fill: "#DCE1EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.475 29.3461C20.987 30.1008 20.987 31.076 21.475 31.8315C21.7763 32.2978 22.2167 32.7534 22.8596 33.0655C25.8611 34.5237 26.5199 36.7034 26.5199 38.6863C26.5199 40.6692 26.5199 42.5902 26.5199 42.5902H19.2852V18.5874H26.5199V22.4913C26.5199 22.4913 26.9995 26.0924 22.8596 28.1121C22.2167 28.4242 21.7763 28.8798 21.475 29.3461Z",
    fill: "#BEC3D2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7574 34.053L19.9255 33.2773C19.5168 33.1042 19.0554 33.1042 18.6468 33.2773L16.8149 34.053C16.1203 34.2694 15.4741 34.6258 14.9384 35.118C13.7917 36.1718 13.498 37.4431 13.498 38.627V42.59H25.0742C25.0742 42.59 25.0742 40.2135 25.0742 38.627C25.0742 37.4431 24.7806 36.1718 23.6339 35.118C23.0982 34.6257 22.452 34.2694 21.7574 34.053Z",
    fill: "url(#paint0_linear_328_2504)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75781 42.2061H28.8126V44.3685H9.75781V42.2061Z",
    fill: "#57545C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75781 16.8091H28.8126V18.9715H9.75781V16.8091Z",
    fill: "#57545C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2852 16.8091H28.8113V18.9715H19.2852V16.8091Z",
    fill: "#2E2E2E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_328_2504",
    x1: 19.2861,
    y1: 42.59,
    x2: 19.2861,
    y2: 33.1475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177BF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DAD9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebViewerExpired);
export default __webpack_public_path__ + "static/media/web_viewer_expired.84442617601e0695a283575cde638923.svg";
export { ForwardRef as ReactComponent };